import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useNotification } from '../../../../../hooks'
import { isDraftOpenAction, useDraftCreationOpener } from '../../../../Draft'
import { MINIMIZED_MODAL_KEY } from '../../../../Modal'
import { RentalPortalApplicantDraftCreateActionSelectModal } from '../../RentalPortalApplicantDraftCreateActionSelectModal'
import { RentalPortalApplicantFormModal } from '../../RentalPortalApplicantFormModal'
import { useRentalPortalApplicantDraft } from '../useRentalPortalApplicantDraft'

export function useCreateRentalPortalApplicant({
  setModal,
  onClose,
  onReload,
}) {
  const { handleAddSuccessNotification } = useNotification()

  const { draft, draftId, setDraft } = useRentalPortalApplicantDraft()

  function closeModal() {
    setModal(null)
  }

  function handleSuccess() {
    setDraft(null, 0)

    onClose()

    handleAddSuccessNotification(
      'RentalPortal.ApplicantFormCreatedNotificationKey'
    )

    onReload?.()
  }

  function openModal({ action, initialValues } = EMPTY_OBJECT) {
    setModal(
      <RentalPortalApplicantFormModal
        initialValues={initialValues}
        isDirtyFromOpen={isDraftOpenAction(action)}
        key={draftId}
        onClose={onClose}
        onSuccess={handleSuccess}
      />
    )
  }

  function handleCreateNew() {
    setDraft(null, 0)
  }

  const handleOpenCreation = useDraftCreationOpener({
    DraftPickerModal: RentalPortalApplicantDraftCreateActionSelectModal,
    closeModal,
    draft,
    draftId,
    minimizeKey: MINIMIZED_MODAL_KEY.RENTAL_PORTAL_APPLICANT_FORM,
    openModal,
    setModal,
    onCreateNew: handleCreateNew,
  })

  return { handleOpenCreation }
}
